import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

import MuiAccountCircleIcon from '@mui/icons-material/AccountCircle'
import MuiAppBar from '@mui/material/AppBar'
import MuiBox from '@mui/material/Box'
import MuiButton from '@mui/material/Button'
import MuiMenu from '@mui/material/Menu'
import MuiMenuItem from '@mui/material/MenuItem'
import MuiToolBar from '@mui/material/Toolbar'
import MuiTypography from '@mui/material/Typography'

import BusinessLogo from '../business-logo'
import { ROUTES } from '../../constants/routes'

import AppConfig from '../../config'

const AppBar = () => {
  const { user } = useSelector((state) => state.persisted.auth)
  const [anchorEl, setAnchorEl] = useState(null)
  const navigate = useNavigate()

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleLogout = () => {
    setAnchorEl(null)
    navigate(ROUTES.LOGOUT)
  }

  return (
    <MuiBox sx={{ flexGrow: 1 }}>
      <MuiAppBar sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <MuiToolBar>
          <Link to="/">
            <BusinessLogo />
          </Link>
          <MuiTypography variant="h5">:: {AppConfig.appName}</MuiTypography>
          <MuiTypography variant="h5" color="error" sx={{ flexGrow: 1, marginLeft: 1 }}>
            {AppConfig.environment.toUpperCase() !== 'PROD' &&
              `[${AppConfig.environment.substring(0, 3).toUpperCase()}]`}
          </MuiTypography>
          {user && (
            <>
              <MuiButton
                sx={{
                  justifyContent: 'flex-end',
                  textTransform: 'none',
                }}
                startIcon={<MuiAccountCircleIcon color="primary" />}
                onClick={handleMenu}
              >
                <MuiTypography color="primary">
                  {user?.given_name} {user?.family_name}
                </MuiTypography>
              </MuiButton>
              <MuiMenu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                // keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MuiMenuItem onClick={handleLogout}>Logout</MuiMenuItem>
              </MuiMenu>
            </>
          )}
        </MuiToolBar>
      </MuiAppBar>
    </MuiBox>
  )
}

export default AppBar
